<template lang="pug">
div
    div.fullwidth
        UHFPDSensorOverview
        hr
        ElectricalPDSensorsOverview
        hr
        OtherPDSensorsOverview
    
</template>

<script>
import UHFPDSensorOverview from '../pdsensors/uhfsensors/UHFPDSensorOverview.vue';
import ElectricalPDSensorsOverview from '../pdsensors/electricalpdsensors/ElectricalPDSensorsOverview.vue';
import OtherPDSensorsOverview from '../pdsensors/otherpdsensors/OtherPDSensorsOverview.vue';

export default {
    components: {
        UHFPDSensorOverview,
        ElectricalPDSensorsOverview,
        OtherPDSensorsOverview,
    },
    meta: {
        de: {
            title: "BSS | TE-Sensoren Übersicht",
            description:
                "Übersicht der Teilentladungssensoren der BSS Hochspannungstechnik GmbH",
        },
        en: {
            title: "BSS | Partial Discharge Sensors Overview",
            description:
                "Overview of the Partial Discharge Sensors of BSS Hochspannungstechnik GmbH",
        },
    },
};

</script>